import script from "./BaseTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTable.vue?vue&type=style&index=0&id=5dc15d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc15d6c"]])

export default __exports__